import * as d3 from 'd3'

export default {
  methods: {

    draw_Reflash(sys, data) {
    
      d3.select(`#CERT`).attr('opacity', sys=='SYS' ? 1 : 0)
      d3.select(`#SCH_MCC`).attr('opacity', sys=='SUBSYS' ? 1 : 0)

      d3.select(`#SYS_TITLE1`).text(sys=='SYS' ? 'System No.' : 'Sub-System No.')
      d3.select(`#SYS_TITLE2`).text(sys=='SYS' ? 'System Description' : 'Sub-System Description')

      d3.select(`#SYS_NO`)
      .attr('fill', sys=='SYS' ? '#EC407A' : '#333')
      .text(data[sys])

      d3.select(`#SYS_DESC`)
      .attr('fill', sys=='SYS' ? '#EC407A' : '#333')
      .text(data[`${sys}_DESC`])

      // Link Icon
      d3.select('#INFO')
      .attr('x', this.getNode(`#SYS_NO`) + 5)
      .attr('xlink:href', sys=='SYS' ? this.HOST + '/icon/info_Red.svg' : this.HOST + '/icon/info_Blue.svg')

      // Certificate & Schedule
      if(sys=='SUBSYS') {
        d3.select(`#SCH_P`).text(data.MCC_P)
        d3.select(`#SCH_A`).text(data.MCC_A)
      }

      this.group.forEach(d=> {
        d.items.forEach(item=> {
          if(sys=='SUBSYS' && item == 'MCC') return

          this.columns.filter(f=> f.name).forEach(col=> {

            if(col.code == 'PRO') {
              let prog = data[`${item}_${col.code}`]

              d3.select(`#${item}_${col.code}_BAR`).transition().duration(300).attr('width', data[`${item}_${col.code}`])
              d3.select(`#${item}_${col.code}`).transition().duration(300)
              .attr('x', prog < 75 ? col.sx + 6 + prog : col.sx + 4 + prog)
              .attr('text-anchor', prog < 75 ? 'start' : 'end')
              .text(prog + '%')
              
            } else {
              this.gmx_textTween(`#${item}_${col.code}`, data[`${item}_${col.code}`], 300, '', null, null, null, null, 0)
              d3.select(`#${item}_${col.code}`).call(this.event_Link, item, data, col)
            }
              
          })
        })
      })
    },
    
  }
}